import { render, staticRenderFns } from "./EmployeePFGFSlipDetails.vue?vue&type=template&id=5454ba6e&scoped=true"
import script from "./EmployeePFGFSlipDetails.vue?vue&type=script&lang=js"
export * from "./EmployeePFGFSlipDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeePFGFSlipDetails.vue?vue&type=style&index=0&id=5454ba6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454ba6e",
  null
  
)

export default component.exports